"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Math_1 = require("../../utils/Math");
/**
 * Logic for dealing with calculating:
 *   - The handle positions of the slider based upon the slider value
 *   - The new slider values from key down events
 */
var SliderValueLogic = /** @class */ (function () {
    function SliderValueLogic(min, max, roundToIntegers) {
        this.min = roundToIntegers ? Math.ceil(min) : min;
        this.max = roundToIntegers ? Math.floor(max) : max;
        this.roundToIntegers = roundToIntegers;
    }
    // Range is 0.0 to 1.0, inclusive
    SliderValueLogic.prototype.calculateSliderPositionAsProportion = function (value) {
        if (this.min > this.max) {
            return NaN;
        }
        var valuePrime = this.roundToIntegers ? Math.round(value) : value;
        var proportion = (valuePrime - this.min) / (this.max - this.min);
        return Math_1.clamp(proportion, 0, 1);
    };
    // 0.0 ===> min, 1.0 ===> max
    SliderValueLogic.prototype.calculateNewSliderValueFromProportion = function (proportion) {
        if (this.min > this.max) {
            return NaN;
        }
        else if (proportion < 0) {
            return this.min;
        }
        else if (proportion > 1) {
            return this.max;
        }
        var newValue = this.roundToIntegers ?
            Math.round(proportion * (this.max - this.min)) + this.min :
            proportion * (this.max - this.min) + this.min;
        return Math_1.clamp(newValue, this.min, this.max);
    };
    SliderValueLogic.prototype.calculateNewSliderValueForKey = function (key, currentValue) {
        var valuePrime = this.roundToIntegers ? Math.round(currentValue) : currentValue;
        var onePercentOfRange = (this.max - this.min) / 100;
        var tenthOfRange = (this.max - this.min) / 10;
        var arrowKeyChangeAmount = this.roundToIntegers ? 1 : onePercentOfRange;
        var pageKeyChangeAmount = this.roundToIntegers ? Math.max(Math.round(tenthOfRange), 1) : tenthOfRange;
        var newValue = valuePrime;
        switch (key) {
            case 'ArrowLeft':
            case 'ArrowDown':
                newValue = valuePrime - arrowKeyChangeAmount;
                break;
            case 'ArrowUp':
            case 'ArrowRight':
                newValue = valuePrime + arrowKeyChangeAmount;
                break;
            case 'PageDown':
                newValue = valuePrime - pageKeyChangeAmount;
                break;
            case 'PageUp':
                newValue = valuePrime + pageKeyChangeAmount;
                break;
            case 'Home':
                newValue = this.min;
                break;
            case 'End':
                newValue = this.max;
                break;
            default:
                return undefined;
        }
        return Math_1.clamp(newValue, this.min, this.max);
    };
    SliderValueLogic.prototype.calculateNewSliderRangeValueForKey = function (key, currentValue) {
        var currentValueDelta = Math.max(currentValue.to - currentValue.from, 0);
        var arrowKeyChangeAmount = (this.max - this.min) / 100;
        var pageKeyChangeAmount = (this.max - this.min) / 10;
        var newValue = currentValue;
        switch (key) {
            case 'ArrowDown':
            case 'ArrowLeft':
                if (currentValue.from > this.min) {
                    var newFromValue = Math.max(currentValue.from - arrowKeyChangeAmount, this.min);
                    newValue = { from: newFromValue, to: newFromValue + currentValueDelta };
                }
                break;
            case 'ArrowUp':
            case 'ArrowRight':
                if (currentValue.to < this.max) {
                    var newToValue = Math.min(currentValue.to + arrowKeyChangeAmount, this.max);
                    newValue = { from: newToValue - currentValueDelta, to: newToValue };
                }
                break;
            case 'PageDown':
                if (currentValue.from > this.min) {
                    var newFromValue = Math.max(currentValue.from - pageKeyChangeAmount, this.min);
                    newValue = { from: newFromValue, to: newFromValue + currentValueDelta };
                }
                break;
            case 'PageUp':
                if (currentValue.to < this.max) {
                    var newToValue = Math.min(currentValue.to + pageKeyChangeAmount, this.max);
                    newValue = { from: newToValue - currentValueDelta, to: newToValue };
                }
                break;
            case 'Home':
                newValue = { from: this.min, to: this.min + currentValueDelta };
                break;
            case 'End':
                newValue = { from: this.max - currentValueDelta, to: this.max };
                break;
            default:
                return undefined;
        }
        return { from: Math_1.clamp(newValue.from, this.min, this.max), to: Math_1.clamp(newValue.to, this.min, this.max) };
    };
    SliderValueLogic.KeysRelevantForManipulatingSlider = {
        'ArrowLeft': true,
        'ArrowRight': true,
        'ArrowUp': true,
        'ArrowDown': true,
        'PageUp': true,
        'PageDown': true,
        'Home': true,
        'End': true
    };
    return SliderValueLogic;
}());
exports.SliderValueLogic = SliderValueLogic;
//# sourceMappingURL=SliderValueLogic.js.map